<template>
    <Modal
        v-model="visible"
        class-name="export-task-submitted-modal vertical-center-modal"
        :closable="false"
        :mask-closable="false"
        footer-hide
        width="416"
    >
        <div class="ivu-modal-confirm">
            <div class="ivu-modal-confirm-head">
                <div class="ivu-modal-confirm-head-icon ivu-modal-confirm-head-icon-success">
                    <Icon type="ios-checkmark-circle" />
                </div>
                <div class="ivu-modal-confirm-head-title">导出任务已提交</div>
            </div>
            <div class="ivu-modal-confirm-body">
                <div>请点击右上角个人头像（账号）下的【导出记录】进行下载</div>
            </div>
            <div class="ivu-modal-confirm-footer">
                <Button @click="handleClose">关闭</Button>
                <Button type="primary" @click="handleGoView">前往查看</Button>
            </div>
        </div>
    </Modal>
</template>

<script>
export default {
    name: "ExportTaskSubmittedModal",
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        open() {
            this.visible = true
        },
        handleClose() {
            this.visible = false
        },
        handleGoView() {
            this.visible = false
            setTimeout(() => {
                this.$emit("go-view")
            }, 200)
        },
    },
}
</script>

<style lang="less">
.export-task-submitted-modal {
    .ivu-modal-header {
        display: none;
    }

    .ivu-modal-body {
        padding: 0;
    }

    .ivu-modal-confirm-footer {
        .ivu-btn + .ivu-btn {
            margin-left: 8px;
        }
    }
}

.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }
}
</style>
